export default __webpack_public_path__ + "static/fastcompany-5144ce1ad770c35d3c9d1e497f45aa98.png";